module.exports = "<p style=\"margin-bottom: 0px;\">\r\n  {{this.data}}\r\n</p>\r\n"